import React from 'react';
import Header from '../components/header';

const HomePage: React.FC = () => <Header screenName="ホーム" />;

export default HomePage;
